export default [
  {
    //header: "Evaluaciones de Desempeño",
    title: "Evaluaciones",
    icon: "FileTextIcon",
    route: "verifiers-performances-list",
    action: "read",
    resource: "performances",
  },
];
